import { Component, OnInit } from '@angular/core';
import { LegalIcon, SocialMedia } from 'src/models/partner-socials.model';
import { KeyValuePipe } from '@angular/common';
import { ThemeService } from 'src/services/theme/theme.service';
import { NavPartner } from 'src/models/partners';
import { TranslateModule } from '@ngx-translate/core';
import { groupArrByKey } from 'src/functions/data-formating.function';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [KeyValuePipe, TranslateModule, RouterModule],
  templateUrl: './footer.html',
  styleUrl: './footer.scss'
})
export class Footer implements OnInit {
  socialIcons!: SocialMedia;
  legalIcons!: LegalIcon[];
  paymentProviders: NavPartner[] = [];
  groupedFooterNav: Record<string, any[]> = {};

  constructor(private themeService: ThemeService) {
    this.socialIcons = {
      facebook: '',
      twitter: '',
      instagram: '',
      linkedin: '',
      telegram: '',
      youtube: '',
      whatsapp: ''
    }
  }

  get theme() {
    return this.themeService.getTheme();
  }

  get currentYear() {
    return new Date().getFullYear();
  }

  ngOnInit(): void {
    this.socialIcons = this.theme.socialMediaLinks;
    this.paymentProviders = this.theme.partners;
    this.legalIcons = this.theme.legalIcons! || [{ src: '', alt: '+18' }];
    this.groupedFooterNav = groupArrByKey(this.theme.footerNavMenu || [], 'context');
  }
}
